module.exports = __webpack_public_path__ + "img/19.086e18e8.png";